import { render, staticRenderFns } from "./GameHUDButton.vue?vue&type=template&id=072d99f2&scoped=true&"
var script = {}
import style0 from "./GameHUDButton.vue?vue&type=style&index=0&id=072d99f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072d99f2",
  null
  
)

export default component.exports